module.exports = __webpack_public_path__ + "img/18.14ede90f.png";